const generateNewReport = "/idar-service/user_prepaid";
const signIn = "/userservice/nopass/alberto/new";
const userInfo = "/idaw-service/userinfo";
const signOut = "/userservice/logout";
const saveMarketingUserData = "/idar-service/person";
const savePersonalAndBillFile = "/idai-service/inscription/";
const payRequest = "/idai-service/start_payment";
const checkDuplicated = "/idai-service/check_duplicated";
const loadManagerByBillIssuer = "/idai-service/get_emisor_factura_gestor?name=";
const loadBrandTypeAndBillIssuer = "/idai-service/get_emisor_factura";
const loadBillIssuerDispatch = "idai-service/get_emisor_factura_despacho";
const saveRequest = "/idai-service/no_auth_login";
const getRequest = (reportId) =>
  `idai-service/get_inscription_data?uuid=${reportId}`;
const getUnSignedDocuments =
  "/searchservice/tenant/doxautoinscripcion/type/idai_poder_simple/from/0/size/500/sort/inserted_at:asc";
const getMyDocuments =
  "/searchservice/tenant/idai/type/idai_solicitud/from/0/size/500/sort/inserted_at:desc";
const saveProfile = (uniqueId) =>
  `/nodeservice/tenant/doxautoinscripcion/node/${uniqueId}/update`;

const reportPreview = (uniqueId) =>
  `/nodeservice/preview/tenant/doxautoinscripcion/node/${uniqueId}`;
const reportDownload = (uniqueId) =>
  `/nodeservice/download/tenant/doxautoinscripcion/node/${uniqueId}`;

const downloadUnSignedDocs = `/idai-service/download_documents_by_username`;
const reportEventStream = (username = "aliuska.lopez@dox.cl") =>
  `/idai-service/sse/inscription/events?username=${username}`;

const cancelRequest = (requestId) =>
  `/idai-service/cancel_request/${requestId}`;
const getDocumentDetail = `/idai-service/get_expediente_sol`;

const getNodeExtraInfo = "/idaw-service/get_tenant/idai";

const downloadMyDetailDocuments = (token, documents = "") =>
  `/idai-service/download_documents_sol?ticket=${token}&data=${documents}`;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  generateNewReport,
  signIn,
  signOut,
  userInfo,
  saveMarketingUserData,
  savePersonalAndBillFile,
  payRequest,
  checkDuplicated,
  loadBrandTypeAndBillIssuer,
  loadManagerByBillIssuer,
  loadBillIssuerDispatch,
  saveRequest,
  getRequest,
  getUnSignedDocuments,
  reportPreview,
  reportDownload,
  downloadUnSignedDocs,
  saveProfile,
  reportEventStream,
  getMyDocuments,
  cancelRequest,
  getDocumentDetail,
  downloadMyDetailDocuments,
  getNodeExtraInfo,
};
